import List from "@mui/material/List";
import OrderItem from "./OrderItem";

function OrderItemList({ items }) {
	return (
		<List className="pt-20">
			{items.map((item, index) => (
				<OrderItem key={index} item={item} />
			))}
		</List>
	);
}

export default OrderItemList;
